export const SET_REPORT_DATE_FILTER = 'reportFilters/SET_REPORT_DATE_FILTER';
export const SET_SALES_BREAKDOWN_VIEW = 'reportFilters/SET_SALES_BREAKDOWN_VIEW';

/** Which split the Sales by Channel / Source card shows (ZAR-2371). Shared by Snapshot + Sales. */
export type SalesBreakdownView = 'channel' | 'source';
